import React from 'react'

export default function Embed(props) {
	return (
		<div style={{ width: '100%', height: '75vh' }}>
			<iframe src={props.src} style={{ width: '100%', height: 'calc(100vh - 66px)' }} title="Embed" />
		</div>
	)
}
